<!--
Author: zhangkun
Date: 2024-05-08
Desc: 转换列表和赎回转申购列表
 -->
<template>
    <div>
        <div class="pl15 pb20 mt5">
            <span class="fs14 c_333">扣款账号：</span>
            <el-select v-model="bankcardid" filterable placeholder="请选择开户行所在省">
                <el-option value="" label="全部">全部</el-option>
                <el-option
                    v-for="item in banks"
                    :key="item.bankcardid"
                    :label="item.channelDisplayText"
                    :value="item.bankcardid"
                />
            </el-select>
        </div>
        <el-table
            v-if="load"
            :data="fundAll"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
            v-on:sort-change="handleSortChange"
        >
            <el-table-column label="产品名称" width="280" class-name="fund-offset">
                <template slot-scope="scope">
                    <div class="c_333 fs14" v-on:click.stop="gotoDetail(scope.row)">
                        {{ scope.row.fundname }}
                        <span v-if="scope.row.assetshowtype == '1'" class="xjbStyle">
                            {{ $const.getXJBParam("name") }}
                        </span>
                    </div>
                    <div class="c_999 fs14">
                        {{ scope.row.fundcode }}
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column label="购买方式" class-name="fund-offset">
                <template slot-scope="scope">
                    {{ scope.row.assetshowtype == "1" ? $const.getXJBParam("name") : "普通产品" }}
                </template>
            </el-table-column> -->
            <el-table-column prop="nav" label="最新净值" align="center" sortable="custom">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.nav, 4) }}
                    </div>
                    <div class="c_999 fs12">
                        {{ $util.fmtDate(scope.row.navdate) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="currentshare" label="持有份额" align="center" sortable="custom">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.currentshare) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                prop="usableremainshare"
                label="可用份额"
                align="center"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.usableremainshare) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="marketvalue" label="参考市值" align="center" sortable="custom">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $util.fmtNum(scope.row.marketvalue) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="基金状态" sortable="custom">
                <template slot-scope="scope">
                    <div class="c_333 fs14">
                        {{ $cache.getDict("130011", scope.row.status) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100">
                <template slot-scope="scope">
                    <div class="flex wcenter hcenter gap11">
                        <div v-if="changeType == 'change'">
                            <el-tooltip
                                v-if="scope.row.isChange"
                                class="item"
                                effect="info"
                                :content="scope.row.isChange + ',不能转换'"
                                placement="top"
                            >
                                <el-button disabled type="text" plain size="small">转换</el-button>
                            </el-tooltip>
                            <el-button
                                v-else
                                type="text"
                                plain
                                size="small"
                                :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                                v-on:click.stop="callbackFn('36', scope.row)"
                            >
                                转换
                            </el-button>
                        </div>
                        <div v-else>
                            <el-tooltip
                                v-if="scope.row.isChange"
                                class="item"
                                effect="info"
                                :content="scope.row.isChange + ',不能赎回转申购'"
                                placement="top"
                            >
                                <el-button disabled type="text" plain size="small">
                                    赎回转申购
                                </el-button>
                            </el-tooltip>
                            <el-button
                                v-else
                                type="text"
                                plain
                                size="small"
                                :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                                v-on:click.stop="callbackFn('22', scope.row)"
                            >
                                赎回转申购
                            </el-button>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="pageRefresh"
            />
        </el-row>
        <dalogChild width="520px" :dialogVisible.sync="showDialog">
            <!-- 插槽内容：自定义对话框体 -->
            <!-- <div slot="content">
            </div> -->
        </dalogChild>
    </div>
</template>

<script>
import fundApi from "@/api/fund";
import dalogChild from "@/components/acctInfo/dalogChild.vue";
export default {
    name: "QuickChange",
    components: { dalogChild },
    props: {
        changeType: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            fundAll: [],
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            sortField: "", // 排序字段
            sortOrder: "", // 排序方向 "" 不排序 "ascending" 升序 "descending" 降序
            curPage: 1, // 当前页
            conf: {}, // 初始化配置文件内容
            bankcardid: "",
            banks: [],
            load: false,
            showDialog: false // 控制对话框显示状态
        };
    },

    watch: {
        bankcardid(val) {
            this.pageoffset = 1;
            this.getList();
        }
    },

    created() {
        this.conf = this.$util.getConfig().const;
    },

    methods: {
        // 表头排序
        handleSortChange({ prop, order }) {
            if (order) {
                this.sortField = prop;
                this.sortOrder = order;
            } else {
                this.sortField = "";
                this.sortOrder = "";
            }
            this.pageoffset = 1;
            this.getList();
        },
        // 切换分页
        pageRefresh(val) {
            this.pageoffset = val;
            this.getList();
        },
        getList() {
            fundApi
                .getAssetsList({
                    producttype: "@",
                    sourceflag: "",
                    keyword: "",
                    transflag: this.changeType == "change" ? "1" : "",
                    pageSize: this.pagecount,
                    pageNum: this.pageoffset,
                    bankcardid: this.bankcardid,
                    isasc: this.sortOrder ? (this.sortOrder === "ascending" ? "1" : "0") : "",
                    orderfield: this.sortField || ""
                })
                .then(async (res) => {
                    this.load = true;
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                    this.fundAll = await this.$util.getFundCodeListDetail(res.data.returnList, [
                        "tradingmethod"
                    ]);
                    this.fundAll.forEach((fund) => {
                        fund.isChange = this.checkChange(fund);
                    });
                    if (this.bankcardid == "") {
                        const rawBanks = res.data.first && res.data.first.transIdGroups;
                        // 预处理渠道显示数据
                        this.banks = rawBanks
                            ? rawBanks.map((item) => this.$util.preprocessChannelData(item))
                            : [];
                    }
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                    if (this.changeType == "change" || this.changeType == "buy") {
                        this.fundAll.forEach((fund) => {
                            if (fund.assetshowtype == "1") {
                                if (fund.fundArr.every((item) => item.transtype === "1")) {
                                    fund.isChange = `该资产为${this.$const.getXJBParam(
                                        "name"
                                    )}资产`;
                                }
                            }
                        });
                    }
                });
        },
        // 点击转换或赎回转申购按钮
        async callbackFn(way, fund) {
            if (this.$util.checkPersonalBuyBusinessDisabled(way == "36" ? "转换" : "赎回转申购")) {
                return;
            }
            let moduleId = way;
            let flag = "0";
            if (moduleId == "22") {
                flag = "0";
            } else {
                flag = "1";
            }
            // 不允许进入交易页面交易
            // 未认证投资者限制交易弹窗业务类型需要根据综合理财勾选的限制业务来提示
            const limitFlag = await this.$util.shouldShowCertificateDialog("0" + moduleId);
            if (limitFlag) {
                this.showDialog = true;
                return;
            }
            // 申购 22 认购 20  转换36  赎回24  预约赎回25
            const _this = this;
            _this.$util.checkGtOcrModule(moduleId, flag, (res) => {
                _this.fundCon(way, fund);
            });
        },
        // 进一步操作
        fundCon(way, fund) {
            const _this = this;
            const checkFund = Object.assign({}, fund, {
                proto: way == "36" ? "change" : "buy"
            });
            if (way == "36") {
                // 转换入口只做进入交易前校验，风险匹配改由转入目标基金判断。
                checkFund.skipCustRiskMatch = true;
            }
            this.$util.fundRiskCheck(this, checkFund, (res) => {
                if (res) {
                    _this.$util.getSdxProtocol(res, (data) => {
                        if (data) {
                            const _x = Object.assign({}, data, { way: way });
                            const name = way == "36" ? "changefund" : "sellBuyFund";
                            sessionStorage.setItem(name, JSON.stringify(_x));
                            this.$router.push({
                                name: name,
                                query: { fundcode: _x.fundcode }
                            });
                        }
                    });
                }
            });
        },
        checkChange(fund) {
            // 快速交易中 转换列表进入转换页面是做转换业务,赎回转购列表进入转换页面是做赎回转购业务 能够明确业务且能够区分扣款账号,因此在进入转换页面做控制
            // 线下渠道份额是否可以进行的转换业务/赎回转购业务
            const code = this.changeType === "change" ? "036" : "099";
            const offlineBusinessCodes = this.$cache.getSysParam("26051901") || "";
            if (
                fund.fundArr &&
                fund.fundArr.every((item) => item.banktype !== "0") &&
                offlineBusinessCodes.indexOf(code) === -1
            ) {
                return "直销柜台购买产品需在直销柜台进行操作";
            }
            return this.$util.checkChange(fund);
        }
    }
};
</script>

<style lang="scss" scoped>
.fund-name {
    color: var(--color-text-primary);
    font-size: 14px;
    cursor: pointer;
}
.el-button.is-plain:hover,
.el-button.is-plain:focus,
.el-button.is-disabled.is-plain {
    background-color: transparent;
    border-color: transparent;
}

.el-button--text {
    font-size: 14px;
    font-weight: normal;
    color: var(--color-primary);
}
.el-button--text.is-disabled {
    color: var(--color-text-weak);
}

::v-deep .el-select > .el-input {
    font-size: 16px;
    color: blue;
}
.el-table {
    border: 1px solid var(--color-divided);
}
.el-table--fit {
    margin-bottom: 15px;
}
.el-pagination {
    margin-bottom: 0;
}
.xjbStyle {
    border: 1px solid var(--color-primary);
    color: var(--color-primary) !important;
    padding: 2px 5px;
}
</style>
